import React, { Dispatch, SetStateAction } from 'react';

export const TitleContext = React.createContext({
  title: '',
  setTitle: (title: any) => {
    return;
  },
});
